import { DossierApi as dossiers, defDossierApi } from "./dossiers";

const Api = {
  dossiers,
  defDossierApi,
};

export default Api;
